// extracted by mini-css-extract-plugin
export default {"wishItemContainer":"AddtoCartAction_wishItemContainer__wQ0qi","wishIcon":"AddtoCartAction_wishIcon__frK1U"};